import React from 'react'
import './css/AboutClients.css'
import AboutClientCard from './AboutClientCard'

import RamanSrivastava from './../assets/clients/Raman Srivastava.jpg'
import AbdulNasserK from './../assets/clients/Abdul Nasser K.jpg'
import AbdulNabeelK from './../assets/clients/Abdul Nabeel K.jpg'
import PKMayanMohammed from './../assets/clients/PKMayanMohammed.jpg'
import NasserKilyamannil from './../assets/clients/Nasser Kilyamannil.jpeg'
import MuhammedMadani from './../assets/clients/Muhammed Madani.jpg'
import ZainudeenBeeravunni from './../assets/clients/Zainudeen Beeravunni.jpeg'
import HassanKunhi from './../assets/clients/Hassan Kunhi.jpg'
import MalabarGND from './../assets/clients/Malabar.jpg'
import SreeVishnuMayaTemple from './../assets/clients/SreeVishnumayaSwamiTemple.jpeg'
import VKShamsudheen from './../assets/clients/V K Shamsudheen.jpg'
import ShriMNKrishnamurthyIPS from './../assets/clients/ShriMN KrishnamurthyIPS.jpg'
import IbrahimThonikkara from './../assets/clients/IbrahimThonnikara.jpeg'
import BasheerKV from './../assets/clients/Basheer KV.jpeg'
import MujeebRahman from './../assets/clients/Mujeeb Rahman.jpg'
import PPAboobacker from './../assets/clients/P P Aboobacker.jpg'
import AydroseRasheedPuthussery from './../assets/clients/Aydrose Rasheed Puthussery.jpeg'

function AboutClients() {
  return (
    <div className='AboutClients'>
        <h1 className='head'>Our Clients</h1>
        <div className='clients'> 
            <AboutClientCard image={AbdulNabeelK} name={"Abdul Nabeel K"} position={"MD - Arabian Garden Restaurant Ltd"} />
            <AboutClientCard image={AbdulNasserK} name={"Abdul Nasser K"} position={"Entrepreneur - Al Karama Group"} />
            <AboutClientCard image={SreeVishnuMayaTemple} name={"Avanangattil Kalari Sree Vishnumaya Temple"} position={"Peringottukara"} />
            <AboutClientCard image={AydroseRasheedPuthussery} name={"Aydrose Rasheed Puthussery"} position={"Director - Relief Medical Solutions"} />
            <AboutClientCard image={BasheerKV} name={"Basheer KV"} position={"Chairman - Ansari Convention Center"} />
            <AboutClientCard image={IbrahimThonikkara} name={"Ibrahim Thonikkara"} position={"MD - Ajzala Super Market"} />
            <AboutClientCard image={MalabarGND} name={"Malabar Gold and Diamonds"} position={"Company"} />
            <AboutClientCard image={HassanKunhi} name={"Methale Purayil Hassan Kunhi"} position={"Director - Asset Homes"} />
            <AboutClientCard image={MuhammedMadani} name={"Muhammed Madani"} position={"Founder & Managing Director ABC Group"} />
            <AboutClientCard image={MujeebRahman} name={"Mujeeb Rahman"} position={"MS - General Surgery"} />
            <AboutClientCard image={NasserKilyamannil} name={"Nasser Kilyamannil"} position={"MD - Educare Institution of Dental Sciences"} />
            <AboutClientCard image={PKMayanMohammed} name={"P.K. Mayan Mohamed"} position={"MD - The Western India Plywoods Ltd"} />
            <AboutClientCard image={PPAboobacker} name={"P.P. Aboobacker"} position={"Chairman - Parco Group"} />
            <AboutClientCard image={RamanSrivastava} name={"Raman Srivastava"} position={"Former DGP - Indian Police"} />
            <AboutClientCard image={ShriMNKrishnamurthyIPS} name={"Shri. MN Krishnamurthy IPS"} position={"Former DGP - Indian Police"} />
            <AboutClientCard image={VKShamsudheen} name={"VK Shamsudeen"} position={"Owner/MD - Fine Tools Trading LLC"} />
            <AboutClientCard image={ZainudeenBeeravunni} name={"Zainudeen Beeravunni"} position={"Group Executive Director of Hotpack Global"} />
        </div>
    </div>
  )
}

export default AboutClients